var _path, _g, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingTagBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 32,
    viewBox: "0 0 116 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H100C108.837 0 116 7.16344 116 16C116 24.8366 108.837 32 100 32H16C7.16345 32 0 24.8366 0 16Z",
    fill: "#FFF2EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9257_81660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2857 16H16.5714",
    stroke: "#FB8137",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9543 11.9541L18.7429 10.7427",
    stroke: "#FB8137",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9543 20.0454L18.7429 21.2568",
    stroke: "#FB8137",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7143 16H31.4286",
    stroke: "#FB8137",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0457 20.0454L29.2571 21.2568",
    stroke: "#FB8137",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 21.7144V23.4286",
    stroke: "#FB8137",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0457 11.9541L29.2571 10.7427",
    stroke: "#FB8137",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 10.2856V8.57129",
    stroke: "#FB8137",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.078 21V10.57H40.872C41.572 10.57 42.188 10.7007 42.72 10.962C43.2613 11.214 43.6813 11.5873 43.98 12.082C44.2787 12.5673 44.428 13.1507 44.428 13.832C44.428 14.504 44.274 15.0827 43.966 15.568C43.6673 16.0533 43.252 16.4267 42.72 16.688C42.188 16.9493 41.572 17.08 40.872 17.08H38.73V21H37.078ZM38.73 15.61H40.914C41.2873 15.61 41.614 15.5353 41.894 15.386C42.174 15.2367 42.3933 15.0313 42.552 14.77C42.7107 14.4993 42.79 14.182 42.79 13.818C42.79 13.454 42.7107 13.1413 42.552 12.88C42.3933 12.6093 42.174 12.404 41.894 12.264C41.614 12.1147 41.2873 12.04 40.914 12.04H38.73V15.61ZM46.1288 21V10.57H53.0028V12.04H47.7808V15.036H52.7228V16.506H47.7808V19.53H53.0028V21H46.1288ZM54.537 21V10.57H55.867L61.719 18.648L61.089 18.746V10.57H62.727V21H61.397L55.587 12.866L56.189 12.754V21H54.537ZM64.8866 21V10.57H68.3026C69.3853 10.57 70.3233 10.7893 71.1166 11.228C71.9193 11.6573 72.5399 12.264 72.9786 13.048C73.4173 13.832 73.6366 14.742 73.6366 15.778C73.6366 16.8047 73.4173 17.7147 72.9786 18.508C72.5399 19.292 71.9193 19.9033 71.1166 20.342C70.3233 20.7807 69.3853 21 68.3026 21H64.8866ZM66.5386 19.53H68.3306C69.0679 19.53 69.7073 19.376 70.2486 19.068C70.7993 18.76 71.2239 18.326 71.5226 17.766C71.8213 17.206 71.9706 16.5433 71.9706 15.778C71.9706 15.0127 71.8166 14.3547 71.5086 13.804C71.2099 13.244 70.7899 12.81 70.2486 12.502C69.7073 12.194 69.0679 12.04 68.3306 12.04H66.5386V19.53ZM75.2635 21V10.57H76.9155V21H75.2635ZM79.078 21V10.57H80.408L86.26 18.648L85.63 18.746V10.57H87.268V21H85.938L80.128 12.866L80.73 12.754V21H79.078ZM94.3136 21.168C93.5763 21.168 92.8903 21.0327 92.2556 20.762C91.6303 20.4913 91.0796 20.118 90.6036 19.642C90.1369 19.1567 89.7729 18.5873 89.5116 17.934C89.2503 17.2807 89.1196 16.562 89.1196 15.778C89.1196 15.0033 89.2456 14.2893 89.4976 13.636C89.7589 12.9733 90.1229 12.404 90.5896 11.928C91.0563 11.4427 91.6023 11.0693 92.2276 10.808C92.8529 10.5373 93.5389 10.402 94.2856 10.402C95.0229 10.402 95.6809 10.528 96.2596 10.78C96.8476 11.032 97.3423 11.3633 97.7436 11.774C98.1449 12.1753 98.4343 12.614 98.6116 13.09L97.1416 13.804C96.9269 13.2347 96.5723 12.7773 96.0776 12.432C95.5829 12.0773 94.9856 11.9 94.2856 11.9C93.5949 11.9 92.9836 12.0633 92.4516 12.39C91.9196 12.7167 91.5043 13.1693 91.2056 13.748C90.9163 14.3267 90.7716 15.0033 90.7716 15.778C90.7716 16.5527 90.9209 17.234 91.2196 17.822C91.5276 18.4007 91.9476 18.8533 92.4796 19.18C93.0116 19.4973 93.6229 19.656 94.3136 19.656C94.8923 19.656 95.4196 19.5393 95.8956 19.306C96.3809 19.0633 96.7683 18.7273 97.0576 18.298C97.3469 17.8593 97.4916 17.3507 97.4916 16.772V16.058L98.2336 16.73H94.2856V15.33H99.1296V16.31C99.1296 17.0753 98.9989 17.7613 98.7376 18.368C98.4763 18.9653 98.1216 19.474 97.6736 19.894C97.2256 20.314 96.7123 20.6313 96.1336 20.846C95.5549 21.0607 94.9483 21.168 94.3136 21.168Z",
    fill: "#974D21"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9257_81660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(16 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingTagBig);
export default __webpack_public_path__ + "static/media/pending-tag-big.21cbb326ff9359cbb8ab337cb8f255c9.svg";
export { ForwardRef as ReactComponent };